/** @jsx jsx */

import { useState, Fragment } from 'react';

import { Icon } from '@zapier/zinnia-icons';
import { Grid, Text } from '@zapier/design-system';
import { jsx } from '@emotion/core';

import ColorSquare from '../ColorSquare';
import { formatDateInUTC } from 'app/developer-v3/utils';

import RowDetails from './RowDetails';
import Styles from './Styles';
import { getEventSummary, prettyType } from '../utils';

import type { EventType } from '../types';

type Props = {
  event: EventType;
};

const TableTextCell = ({ content }) => (
  <td css={Styles.cell}>
    <Text>{content}</Text>
  </td>
);

function CollapsibleRow({ event }: Props) {
  const [isCollapsed, setIsCollapsed] = useState(true);

  return (
    <Fragment>
      <tr aria-label="Event Row">
        <td aria-label={`Event Category ${event.category}`} css={Styles.cell}>
          <ColorSquare colorKey={event.category} />{' '}
        </td>
        <TableTextCell content={formatDateInUTC(new Date(event.date))} />
        <TableTextCell content={prettyType(event.object_type)} />
        <TableTextCell content={event.object_action} />
        <TableTextCell content={event.fork} />
      </tr>
      <tr
        aria-label="See event details"
        css={Styles.clickableRow}
        onClick={() => setIsCollapsed(!isCollapsed)}
      >
        <td colSpan={5} css={Styles.clickableCell}>
          <Grid alignItems="center" columns="24px auto" gap={5}>
            <Icon
              aria-label="Click to see details"
              color="Blue3"
              name={isCollapsed ? 'arrowSmallDown' : 'arrowSmallUp'}
              size={24}
            />
            <Text fontWeight={600}>{getEventSummary(event)}</Text>
          </Grid>
        </td>
      </tr>
      {!isCollapsed && (
        <tr>
          <td colSpan={5}>
            <RowDetails event={event} />
          </td>
        </tr>
      )}
    </Fragment>
  );
}

export default CollapsibleRow;
